import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions, Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import Translation from "../../../../common/translation/translation.component";
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import {
    ORFButton
    , OR_RRF_TextArea as TextArea
    , OR_RRF_InputField as InputField
    , OR_RRF_Select as Select
    , ORFSearchSuggestions as SearchSuggestions
} from '../../../../common/forms/order-request-form.component';
import DATEPICKER_OR from '../../../../common/custom-form/custom-date-picker.component';
import { wirelineChangeVendorActions } from "./../../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-change-vendor.reducer";
import { createRequestActions } from "./../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../store/external/request-reducer/request-log.reducer";
import { fileAttachmentActions } from "./../../../../../store/external/common-reducer/file-attachment.reducer";
import FileAttachment from '../../../../common/file-attachment/file-attachment.component';
import { trueFalseToBoolean, convertToUtcDate } from '../../../../../utils/helpers.utils';
import Icons from '../../../../icon';
import { CIRCUIT_STATUS, SUBMIT_REQUEST, SUBMIT_REQUEST_TITLE } from '../../../../../constants/external-constants';
import { NotificationModal } from '../../../../common/modal/notification-modal.component';
import { ConfirmationNotificationModal } from '../../../../common/modal/confirmation-modal.component';
import { requestDetailsActions } from '../../../../../store/external/request-reducer/request-details.reducer';
import { Loading } from '../../../../common/loading';
class WirelineChangeVendorForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            needByDate: '',
            localToggle: false,
            alterToggle: false,
            showContactFormInfo:false,
            error: false,
            showConModal:false,
            show:false,
            message:'',
            isLoading: true, 
        }
    }

    async componentDidMount() {
        const { isUpdateRequest, takeActionCircuitCode, takeActionCircuitId } = this.props.createRequest;
        const { resetApproverDetails, setCountryName, countryName, requestDetail, onUpdateForm, 
            fetchEmployeeByValue, fetchSubscriptionByValue, fetchSubscriptionByCircuitCode, onSubscriptionSelect } =this.props;
        var circuitCodePropName = 'CircuitCode';
        var subscriptionList = null;
        setCountryName(countryName);

        if(isUpdateRequest){
            const selectedItem = requestDetail.requestData.Order;
            const currentCircuitCode = requestDetail.requestData.Circuit.CircuitCode;

            if(selectedItem?.IsRequestedInBehalf){
                await fetchSubscriptionByCircuitCode(currentCircuitCode, "CircuitCode", selectedItem.IsRequestedInBehalf);
                await fetchEmployeeByValue(requestDetail.requestData.WireLineApprover.Name, 'Name');
                await onUpdateForm().then(() => {
                    this.setState({isLoading:false});
                });
            }

            else{
                await fetchSubscriptionByValue(currentCircuitCode);
                await fetchEmployeeByValue(requestDetail.requestData.WireLineApprover.Name, 'Name');
                await onUpdateForm().then(() => {
                    this.setState({isLoading:false});
                });
            }
        }
        else{
            resetApproverDetails();
        }

         if (takeActionCircuitId != null || takeActionCircuitId !== undefined || takeActionCircuitCode) {
        
            subscriptionList = await fetchSubscriptionByValue(takeActionCircuitCode, circuitCodePropName);

            onSubscriptionSelect(takeActionCircuitCode, circuitCodePropName, subscriptionList, null, takeActionCircuitId);
        }
        else {
            onSubscriptionSelect('');
            if(takeActionCircuitId === undefined)
            {
            subscriptionList = await fetchSubscriptionByValue(null, circuitCodePropName);
            }
        }
        this.setState({isLoading:false});
    }

    componentWillUnmount() {
        this.props.resetWirelineChangeVendorForm();
        this.props.resetRequestData();
        this.props.resetApproverDetails();
        this.props.resetFileAttachment();
    }

    submitRequest = async () => {

        this.setState({showConModal:true})
    }

    handleConfirmationModal = async (buttonType) => {
        const { submitRequest, fetchRequestLogItems, uploadFile, saveOrderFile } = this.props;
        if (buttonType === CONFIRMATION_VALUE.Ok) {
             
              this.setState( prev => ({
                isSaving:true,
             }))

            var success = await submitRequest();
            if (success.Success) { 
                var res = await uploadFile(success.OrderId);
                if (res != null && res.Result) {
                    saveOrderFile(success.OrderId, res.FileNames);
                }             
                this.setState({
                    title:"Success"
                })
                this.props.hideRequestModal(); 
                fetchRequestLogItems(0);
            }else {
                this.setState({
                    title:"Error"
                })
            }
            this.setState( prev => ({
                showConModal: !prev.showConModal,
                show:true, 
                isSaving:false,                   
                message:success.Message
            }))
        }else{
            this.setState({
                showConModal: false
            });
        }
    }

    onSubscriptionSelect = async (value, propsName, objects) => {
        await this.props.onSubscriptionSelect(value, propsName, objects);
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose) {
            modalClose();
        }
    }

    setNeedByDate = (v) => {
        this.setState({
            needByDate: v
        });
    }

    toggleLocalContainer() {
        this.setState({ localToggle: !this.state.localToggle })
    }

    toggleAlterContainer() {
        this.setState({ alterToggle: !this.state.alterToggle })
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    haveError = (value) => {
        this.setState({
            error: value
        })
    }

    handleCloseNotif = () => {
        this.setState({ show: false, isSaving:false });
        if(this.state.title!=="Error")
        {            
            this.props.history.goBack();
        }
    }


    render() {
        const {
            //form
            wirelineChangeVendorFormA
            //reducer action
            , onEmployeeSelect
            , fetchSubscriptionByValue
            , fetchEmployeeByValue
            , onVendorSelect
            , onChangeExpedite
        } = this.props;

        const { subscriptionList, employeeList, takeActionCircuitCode, isUpdateRequest } = this.props.createRequest;
        const { preferredVendorOptions, accountOptions, formSubmitted, subscription, isResetLoading } = this.props.wirelineChangeVendorRequest;
        const { showContactFormInfo } = this.state;
        const { requestData } = this.props.requestDetail;
        const initialRequired = wirelineChangeVendorFormA.circuitId == 0
                                || wirelineChangeVendorFormA.vendorDetailId == 0
                                || wirelineChangeVendorFormA.financeAccountId == 0
                                || wirelineChangeVendorFormA.wireLineApproverId == 0
                                || !wirelineChangeVendorFormA.needByDate
                                || (wirelineChangeVendorFormA.expediteRequest !== 0 ? (trueFalseToBoolean(wirelineChangeVendorFormA.expediteRequest) && wirelineChangeVendorFormA.businessJustification == '') : true)
                                || formSubmitted

        const updateRequired = isUpdateRequest ? !(requestData.Circuit?.CircuitId != wirelineChangeVendorFormA?.circuitId
            || requestData.Circuit?.CircuitCode != wirelineChangeVendorFormA?.circuitCode
            || requestData.NewRequest.Vendor.VendorDetailId.toString() != wirelineChangeVendorFormA.vendorDetailId 
            || requestData.NewRequest.Account.FinanceAccountId.toString() != wirelineChangeVendorFormA.financeAccountId
            || requestData.WireLineApprover.EmployeeId != wirelineChangeVendorFormA.wireLineApproverId
            || convertToUtcDate(requestData.Order.NeedByDate) != convertToUtcDate(wirelineChangeVendorFormA.needByDate)
            || (wirelineChangeVendorFormA.expediteRequest !== 0 ? requestData.BusinessWireline.ExpediteRequest.toString() != wirelineChangeVendorFormA.expediteRequest : true) 
            || requestData.BusinessJustification.BusinessJustification != wirelineChangeVendorFormA.businessJustification
            || requestData.BusinessJustification.AdditionalInformation != wirelineChangeVendorFormA.additionalInformation
            ) : false;

        let minDate = new Date();
        minDate.setDate(minDate.getDate() + 1);

        let expediteOptions = wirelineChangeVendorFormA.circuitId == 0 ?
            [] : [
            {
                "Key": true,
                "Value": "Yes"
            },
            {
                "Key": false,
                "Value": "No"
            }
        ];

        if(this.state.isLoading) {
            return <Loading />
         }  

        return (
            <div>
                <NotificationModal
                    show={this.state.show}
                    title={this.state.title}
                    message={this.state.message}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal confirmation-blur-background notification-footer modal-text-bold'}
                />

                 <ConfirmationNotificationModal 
                    show={this.state.showConModal} 
                    message={isUpdateRequest ? SUBMIT_REQUEST.updateRequest : SUBMIT_REQUEST.submitRequest}
                    title={isUpdateRequest ? SUBMIT_REQUEST_TITLE.updateRequest :SUBMIT_REQUEST_TITLE.submitRequest}
                    handleModal={this.handleConfirmationModal}
                    disabled={this.state.isSaving}
                    customClass={'comment-notification-modal confirmation-blur-background modal-text-bold'}
                />

                <Form method="post" role="form"
                    model="wirelineChangeVendorFormA"
                    onSubmit={this.submitRequest}
                >
                    <Row>
                        <Col xs={12} md={12} lg={12} className="required subscription_container">
                            {
                                !isResetLoading &&
                                
                                <SearchSuggestions
                                    //key={wirelineChangeVendorFormA.circuitCode}
                                    value={wirelineChangeVendorFormA.circuitCode}
                                    label={`${this.toLocaleLanguage('subscription_number')}`}
                                    propDisplay={'CircuitCode'}
                                    options={subscriptionList.length > 0 ? subscriptionList : ''}
                                    onChangeAction={this.onSubscriptionSelect}
                                    searchAction={fetchSubscriptionByValue}
                                    errorMessage={this.toLocaleLanguage('error_subscription_not_exist')}
                                    haveError={this.haveError}
                                    //defaultValue={takeActionCircuitCode}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                />
                            }                           
                            {wirelineChangeVendorFormA.circuitCode != '' &&
                                <div className="pb-15-pl-30">
                                    <span className={subscription.CircuitStatus === CIRCUIT_STATUS.inService.name ? "status-inservice" : "status-suspended"}>{subscription.CircuitStatus} </span> <span>| </span>
                                    {subscription.VendorName ? subscription.VendorName : <Translation translationKey="no_vendor" />} <span>| </span> 
                                    {subscription.CircuitTypeName ? subscription.CircuitTypeName : <Translation translationKey="no_circuit_type_available" /> } <span>| </span> 
                                    {subscription.SubCircuitTypeName ? subscription.SubCircuitTypeName : <Translation translationKey="no_sub_circuit_type_available" />}
                                </div>
                            }
                        </Col>
                    </Row>
                    <span className='text-field-title'><Translation translationKey="change_new_vendor_capital" /></span>
                    <Row>
                        <Col xs={12} md={12} lg={12} className="custom-margin mt-4">
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('new_vendor')}`}
                                value={wirelineChangeVendorFormA.vendorDetailId}
                                options={preferredVendorOptions}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.vendorDetailId'
                                onChangeAction={onVendorSelect}
                                requiredField={true}
                                disabled={wirelineChangeVendorFormA.circuitId == 0}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className="custom-margin mt-4">
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('new_billing_account')}`}
                                value={wirelineChangeVendorFormA.financeAccountId}
                                options={accountOptions}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.financeAccountId'
                                requiredField={true}
                                disabled={wirelineChangeVendorFormA.circuitId == 0
                                    || wirelineChangeVendorFormA.vendorDetailId == 0}
                                /> 
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className="custom-margin mt-4">
                            {
                                !isResetLoading &&
                                <SearchSuggestions
                                    value={wirelineChangeVendorFormA.employeeName}
                                    label={`${this.toLocaleLanguage('approver')}`}
                                    propDisplay={'Name'}
                                    options={employeeList.length > 0 ? employeeList : ''}
                                    onChangeAction={onEmployeeSelect}
                                    searchAction={fetchEmployeeByValue}
                                    requiredField={true}
                                    disabled={wirelineChangeVendorFormA.circuitId == 0}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                    key={wirelineChangeVendorFormA.circuitCode}
                                />
                            }
                        </Col>
                    </Row>
                    {
                        showContactFormInfo &&
                        <div className="local-contact-container" onClick={this.toggleLocalContainer.bind(this)}>
                            <Icons
                                customClassName="icon-circle-plus"
                                name={this.state.localToggle ? `circle-minus-reg` : `circle-plus-reg`}
                                size="20px"
                                containerClass="icon-circle-plus-container"
                            />
                            <h1 className="local-contact-header"><Translation translationKey="local_contact_title" /></h1>
                        </div>
                    }
                    
                    {this.state.localToggle ?
                        <div className="local-list-container">
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('local_contact_email_address')} *`}
                                        value={wirelineChangeVendorFormA.localContactEmail}
                                        fieldProp='.localContactEmail'
                                        disabled={wirelineChangeVendorFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('local_contact_fullname')} *`}
                                        value={wirelineChangeVendorFormA.localContactFullName}
                                        fieldProp='.localContactFullName'
                                        disabled={wirelineChangeVendorFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('local_contact_phone_number')} *`}
                                        value={wirelineChangeVendorFormA.localContactPhone}
                                        fieldProp='.localContactPhone'
                                        disabled={wirelineChangeVendorFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                        </div>
                        : ""}
                    {
                         showContactFormInfo &&
                         <div className="local-contact-container" onClick={this.toggleAlterContainer.bind(this)}>
                            <Icons
                                customClassName="icon-circle-plus"
                                name={this.state.alterToggle ? `circle-minus-reg` : `circle-plus-reg`}
                                size="20px"
                                containerClass="icon-circle-plus-container"
                            />
                            <h1 className="local-contact-header"><Translation translationKey="alt_local_contact_title" /></h1>
                        </div>
                    }
                   
                    {this.state.alterToggle ?
                        <div className="alter-list-container">
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('alt_local_contact_email_address')} *`}
                                        value={wirelineChangeVendorFormA.altLocalContactEmail}
                                        fieldProp='.altLocalContactEmail'
                                        disabled={wirelineChangeVendorFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12} className={`${parseInt(wirelineChangeVendorFormA.circuitId) !== 0 ? "required" : ""}`}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('alt_local_contact_full_name')}`}
                                        value={wirelineChangeVendorFormA.altLocalContactFullName}
                                        fieldProp='.altLocalContactFullName'
                                        disabled={wirelineChangeVendorFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12} className={`${parseInt(wirelineChangeVendorFormA.circuitId) !== 0 ? "required" : ""}`}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('alt_local_contact_phone_number')}`}
                                        value={wirelineChangeVendorFormA.altLocalContactPhone}
                                        fieldProp='.altLocalContactPhone'
                                        disabled={wirelineChangeVendorFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                        </div>

                        : ""}
                    <Row>
                        <Col xs={6} md={6} lg={6} className="required">                            
                            <div className={`date-picker-group ${wirelineChangeVendorFormA.circuitId=== 0 ? "disabled" : ""}`}>
                                <DATEPICKER_OR 
                                    label={`${this.toLocaleLanguage('need_by_date')}`}
                                    placeholder="Select Date"
                                    startDate={wirelineChangeVendorFormA.needByDate}
                                    selectedDate={(date) => this.props.FormChange("wirelineChangeVendorFormA.needByDate", date)}
                                    requiredField={true}
                                    isDisable={wirelineChangeVendorFormA.circuitId == 0}
                                    displayPlaceholderWhenDisabled={true}
                                />
                            </div>    
                        </Col>

                        <Col xs={6} md={6} lg={6}>
                            <div className="form-select-container">
                                <Select
                                    className="form-control"
                                    placeholder="Select..."
                                    label={`${this.toLocaleLanguage('expedite_request')}`}
                                    value={wirelineChangeVendorFormA.expediteRequest}
                                    onChangeAction={onChangeExpedite}
                                    options={expediteOptions}
                                    fieldProp='.expediteRequest'
                                    requiredField={true}
                                    disabled={wirelineChangeVendorFormA.circuitId == 0}
                                />
                            </div>
                        </Col>
                    </Row>
                   
                    <Row>
                        <Col xs={12} md={12} lg={12} className="custom-margin mt-4">
                            <TextArea
                                label={`${this.toLocaleLanguage('business_justification')}`}
                                fieldProp='.businessJustification'
                                value={wirelineChangeVendorFormA.businessJustification}
                                disabled={wirelineChangeVendorFormA.circuitId == 0 || (wirelineChangeVendorFormA.expediteRequest !== 0 ? !trueFalseToBoolean(wirelineChangeVendorFormA.expediteRequest) : true) }
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                requiredField={wirelineChangeVendorFormA.expediteRequest === "true" ? true : false}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className="custom-margin">
                            <TextArea
                                label={this.toLocaleLanguage('additional_information')}
                                fieldProp='.additionalInformation'
                                value={wirelineChangeVendorFormA.additionalInformation}
                                disabled={wirelineChangeVendorFormA.circuitId == 0}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={3} md={3} lg={3}>
                            <FileAttachment isUpdate= {isUpdateRequest} requestFileName={requestData.Order != undefined ? requestData.Order.OrderFileNames : null} />
                        </Col>
                    </Row>
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <ORFButton
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={this.onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <ORFButton
                                    label={this.toLocaleLanguage('submit_request_button')}
                                    variant={"primary"}
                                    type="submit"
                                    disabled={isUpdateRequest ? (initialRequired || updateRequired) : initialRequired}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default withRouter (connect(
    state => {
        const { wirelineChangeVendorRequest, createRequest, translation, requestDetail } = state;
        const { wirelineChangeVendorFormA } = state.form;
        return {
            wirelineChangeVendorRequest
            , wirelineChangeVendorFormA
            , createRequest
            , requestDetail
            , ...translation
        };
    }
    , dispatch =>({
        ...bindActionCreators(
            Object.assign({}, wirelineChangeVendorActions
                , createRequestActions
                , requestLogActions
                , fileAttachmentActions
                , requestDetailsActions
            ),
            dispatch,
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })       
)(WirelineChangeVendorForm));